import { createSelector, weakMapMemoize } from 'reselect'
import { deriveKidsFlyFreeDates } from 'lib/charterFlights/kidsFlyFreeUtils'

const selectFlightData = (state: App.State, searchKey: string) =>
  state.flights.searchV2Flights[searchKey]

export const selectKidsFlyFreeDates = createSelector(
  selectFlightData,
  (flightData): Set<string> => deriveKidsFlyFreeDates(flightData?.fares?.[0]),
  { memoize: weakMapMemoize, argsMemoize: weakMapMemoize },
)
